export function videoSchemaBuilder(options) {
    return {
        url: {
            type: 'url',
            required: true,
        },
        width: {
            type: 'int',
            min: 1,
            required: true,
        },
        height: {
            type: 'int',
            min: 1,
            required: true,
        },
        durationMs: {
            displayName: 'Duration (ms)',
            type: 'int',
            min: 1,
            required: true,
        },
        autoplay: {
            type: 'bool',
        },
        loop: {
            type: 'bool',
        },
        posterImage: {
            displayName: 'Poster Image',
            type: 'array',
            elementType: 'object',
            elementSubtype: 'Image',
            elementUniqueIdFieldName: 'origUrl',
            maxCount: 1,
            keepAspectRatio: 'contain',
            required: true,
            size: options.posterImageDimensions,
            tooltip: {
                text: 'This image will appear briefly on video player while the video is loading.',
            },
        },
        ...(options.thumbnailDimensions && {
            thumbnails: {
                type: 'array',
                elementType: 'object',
                elementSubtype: 'Image',
                elementUniqueIdFieldName: 'origUrl',
                maxCount: 1,
                keepAspectRatio: 'contain',
                required: true,
                size: options.thumbnailDimensions,
            },
        }),
    };
}
//# sourceMappingURL=video_schema.js.map